import React, { useEffect } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./Experience.css";
import { experience } from "../../portfolio.js";
import { Fade } from "react-reveal";
import ExperienceImg from "./ExperienceImg";
import ExperienceTimeline from "../../containers/experienceTimeline/ExperienceTimeline";

function Experience(props) {
  const theme = props.theme;

  // Set CSS variables for gradient colors based on theme
  useEffect(() => {
    document.documentElement.style.setProperty("--text-color", theme.text);
    document.documentElement.style.setProperty(
      "--accent-color",
      theme.accentColor,
    );

    // Extract RGB values from the accent color for use in rgba()
    const hexToRgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
            result[3],
            16,
          )}`
        : null;
    };

    document.documentElement.style.setProperty(
      "--accent-rgb",
      hexToRgb(theme.accentColor),
    );
  }, [theme]);

  return (
    <div className="experience-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-experience">
        <Fade bottom duration={2000} distance="40px">
          <div className="experience-heading-div">
            <div className="experience-heading-img-div">
              <ExperienceImg theme={theme} />
            </div>
            <div className="experience-heading-text-div">
              <h1
                className="experience-heading-text"
                style={{ color: theme.text }}
              >
                {experience.title}
              </h1>
              <h3
                className="experience-heading-sub-text"
                style={{ color: theme.text }}
              >
                {experience["subtitle"]}
              </h3>
              <p
                className="experience-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {experience["description"]}
              </p>
            </div>
          </div>
        </Fade>
      </div>

      <ExperienceTimeline sections={experience["sections"]} theme={theme} />

      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Experience;
